import Vue from "vue";

// 按需引入vant组件
import {
  Icon,
  Image,
  Col,
  Row,
  Button,
  Search,
  Swipe,
  SwipeItem,
  Grid,
  GridItem,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Tab,
  Tabs,
  NavBar,
  ShareSheet ,
  Card,
  Tag,
  Checkbox,
  CheckboxGroup,
  Stepper,
  Step,
  Steps,
  SubmitBar,
  Cell,
  AddressList,
  CellGroup,
  Radio,
  RadioGroup,
  SwipeCell,
  Field,
  CouponCell,
  AddressEdit,
  Rate,
  Overlay,
  Loading,
  Skeleton,
  Lazyload,
  Toast,
  Popup,
  Area,
  Dialog,
  PullRefresh,
  Uploader,
  Picker,
  Switch,
  Form,
  ImagePreview,
  ActionSheet,
  Badge,
  CountDown,
  List,
  Cascader,
} from "vant";
import "vant/lib/index.css";

//按需安装Vant组件
Vue.use(Lazyload, {
  lazyComponent: true,
});

Vue.use(Icon)
  .use(Dialog)
  .use(Toast)
  .use(ImagePreview)
  .use(List)
  .use(Cascader)
  .use(ActionSheet)
  .use(CountDown)
  .use(Step)
  .use(Form)
  .use(Switch)
  .use(Picker)
  .use(Uploader)
  .use(Steps)
  .use(Area)
  .use(PullRefresh)
  .use(Popup)
  .use(Skeleton)
  .use(Loading)
  .use(Overlay)
  .use(Field)
  .use(CouponCell)
  .use(AddressEdit)
  .use(Rate)
  .use(Image)
  .use(Col)
  .use(Row)
  .use(Button)
  .use(Search)
  .use(Swipe)
  .use(SwipeItem)
  .use(Grid)
  .use(GridItem)
  .use(GoodsAction)
  .use(GoodsActionIcon)
  .use(GoodsActionButton)
  .use(Tab)
  .use(Tabs)
  .use(NavBar)
  .use(Card)
  .use(Tag)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Stepper)
  .use(SubmitBar)
  .use(Cell)
  .use(AddressList)
  .use(CellGroup)
  .use(Radio)
  .use(RadioGroup)
  .use(SwipeCell)
  .use(ShareSheet)
  .use(Badge);
